// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BulkTaskAllocationModal_GlobalPlanTasksQueryVariables = Types.Exact<{
  filter: Types.GlobalPlanTaskFilter;
}>;


export type BulkTaskAllocationModal_GlobalPlanTasksQuery = { __typename?: 'Query', globalPlanTasks: { __typename?: 'GlobalPlanTasksPageResult', entities: Array<{ __typename?: 'GlobalPlanTask', id: string, name: string }> } };


export const BulkTaskAllocationModal_GlobalPlanTasksDocument = gql`
    query BulkTaskAllocationModal_GlobalPlanTasks($filter: GlobalPlanTaskFilter!) {
  globalPlanTasks(filter: $filter, page: {limit: 10000}) {
    entities {
      id
      name
    }
  }
}
    `;

/**
 * __useBulkTaskAllocationModal_GlobalPlanTasksQuery__
 *
 * To run a query within a React component, call `useBulkTaskAllocationModal_GlobalPlanTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkTaskAllocationModal_GlobalPlanTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkTaskAllocationModal_GlobalPlanTasksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBulkTaskAllocationModal_GlobalPlanTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BulkTaskAllocationModal_GlobalPlanTasksQuery, BulkTaskAllocationModal_GlobalPlanTasksQueryVariables> & ({ variables: BulkTaskAllocationModal_GlobalPlanTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkTaskAllocationModal_GlobalPlanTasksQuery, BulkTaskAllocationModal_GlobalPlanTasksQueryVariables>(BulkTaskAllocationModal_GlobalPlanTasksDocument, options);
      }
export function useBulkTaskAllocationModal_GlobalPlanTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulkTaskAllocationModal_GlobalPlanTasksQuery, BulkTaskAllocationModal_GlobalPlanTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkTaskAllocationModal_GlobalPlanTasksQuery, BulkTaskAllocationModal_GlobalPlanTasksQueryVariables>(BulkTaskAllocationModal_GlobalPlanTasksDocument, options);
        }
export function useBulkTaskAllocationModal_GlobalPlanTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkTaskAllocationModal_GlobalPlanTasksQuery, BulkTaskAllocationModal_GlobalPlanTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BulkTaskAllocationModal_GlobalPlanTasksQuery, BulkTaskAllocationModal_GlobalPlanTasksQueryVariables>(BulkTaskAllocationModal_GlobalPlanTasksDocument, options);
        }
export type BulkTaskAllocationModal_GlobalPlanTasksQueryHookResult = ReturnType<typeof useBulkTaskAllocationModal_GlobalPlanTasksQuery>;
export type BulkTaskAllocationModal_GlobalPlanTasksLazyQueryHookResult = ReturnType<typeof useBulkTaskAllocationModal_GlobalPlanTasksLazyQuery>;
export type BulkTaskAllocationModal_GlobalPlanTasksSuspenseQueryHookResult = ReturnType<typeof useBulkTaskAllocationModal_GlobalPlanTasksSuspenseQuery>;
export type BulkTaskAllocationModal_GlobalPlanTasksQueryResult = Apollo.QueryResult<BulkTaskAllocationModal_GlobalPlanTasksQuery, BulkTaskAllocationModal_GlobalPlanTasksQueryVariables>;